



























import { Component, Prop, Vue } from 'vue-property-decorator';
import Plant from '@/models/plant';
import { getById as getPlantById } from '@/api/plants';
import HeaderNavbar from '../Header/Navbar.vue';

import PlantDetails from './PlantDetails.vue';
import ApiKeys from './ApiKeys.vue';
import HealthCheckConfig from './HealthCheckConfig.vue';

@Component({
  components: {
    PlantDetails,
    ApiKeys,
    HealthCheckConfig,
    HeaderNavbar
  }
})
export default class PlantView extends Vue {
  @Prop([Number, String]) readonly id!: number | 'new';
  loading: boolean = true;
  error: string = '';
  plant: Plant = { name: '' };

  async mounted() {
    await this.fetch();
  }

  get isNew() {
    return this.id === 'new';
  }

  async fetch() {
    if (this.isNew) {
      this.loading = false;
      return;
    }

    try {
      this.loading = true;
      this.plant = await getPlantById(this.id as number);
    } catch (e) {
      this.error = e.message;
      this.$toast.open({ message: e.message, type: 'is-danger' });
    } finally {
      this.loading = false;
    }
  }
}
